var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.1875 17.1406C10.3709 19.443 11.125 29.7188 11.125 29.7188C11.125 29.7188 11.8791 19.443 22.0625 17.1406C11.8791 14.8383 11.125 4.5625 11.125 4.5625C11.125 4.5625 10.3709 14.8383 0.1875 17.1406Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7812 24.25C24.3818 25.4531 24.7969 30.8125 24.7969 30.8125C24.7969 30.8125 25.212 25.4531 30.8125 24.25C25.212 23.0469 24.7969 17.6875 24.7969 17.6875C24.7969 17.6875 24.3818 23.0469 18.7812 24.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9531 6.75C20.5537 7.95312 20.9688 13.3125 20.9688 13.3125C20.9688 13.3125 21.3838 7.95312 26.9844 6.75C21.3838 5.54688 20.9688 0.1875 20.9688 0.1875C20.9688 0.1875 20.5537 5.54688 14.9531 6.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarLogo);
export default __webpack_public_path__ + "static/media/star-logo.fa5f89baef009279a3b11f93d7ce5d80.svg";
export { ForwardRef as ReactComponent };